import { AfterViewInit, Component, inject, OnDestroy } from '@angular/core';
import { AuthenticatorService } from '../../core/service/authenticator.service';
import { tap } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { AppTranslateService } from 'src/app/core/service/translate.service';

const GOOGLE_CLIENT_ID = '96489767858-b3d4akiokrm1ioop6dg77j774urmnprb.apps.googleusercontent.com';
const GOOGLE_SCRIPT_URL = 'https://accounts.google.com/gsi/client';

declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (options: {client_id: string, callback: (response: unknown) => void}) => void
          renderButton: (element: HTMLElement, options: unknown) => void
          prompt: () => void
          cancel: () => void
        }
      }
    }
  }
}


@Component({
  selector: 'app-google-onetap',
  template: ``
})
export class GoogleOnetapComponent implements AfterViewInit, OnDestroy {
  private authenticator = inject(AuthenticatorService);
  private translate = inject(AppTranslateService);

  ngAfterViewInit(): void {
    if (!this.authenticator.isAuthed) {
      this.loadScript(GOOGLE_SCRIPT_URL)
        .then(() => this.initOneTap())
        .catch(() => console.error('Failed to load Google One Tap script'));
    }
  }

  ngOnDestroy(): void {
    window.google?.accounts.id.cancel();
  }

  private initOneTap(): void {
    if (!window.google?.accounts?.id) return;

    window.google.accounts.id.initialize({
      client_id: GOOGLE_CLIENT_ID,
      callback: (response: any) => {
        if (response instanceof Object && 'credential' in response && typeof response.credential === 'string') {
          const user = jwtDecode(response.credential);
          this.authenticator.idpLogin('google_onetap', user, this.translate.getCurrentLanguage(), true).pipe(
            tap(data => location.href = data.redirectUri)
          ).subscribe()
        }
      }
    });

    window.google.accounts.id.prompt();
  }

  private loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));

      document.body.appendChild(script);
    });
  }
}
